import {
  isLaborOwnerDeparting,
  subscribeLaborOwnerDeparting,
} from "@/lib/labor/laborOwnerDeparture";

/** Resolves when the owning tab finishes silent clock-out / handoff from SPA navigation. */
export function waitForLaborOwnerDepartureComplete(): Promise<void> {
  if (!isLaborOwnerDeparting()) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    const unsubscribe = subscribeLaborOwnerDeparting(() => {
      if (!isLaborOwnerDeparting()) {
        unsubscribe();
        resolve();
      }
    });
  });
}
